<template>
  <div :class="['content-item', getJustify, getSpaceTop, getSpaceBottom]">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'content-item',
  props: {
    justifyContent: {
      type: String,
      default: 'center'
    },
    spaceTop: {
      type: String,
      default: 'none'
    },
    spaceBottom: {
      type: String,
      default: 'none'
    }
  },
  computed: {
    getJustify() {
      return `content-item--${this.justifyContent}`
    },
    getSpaceTop() {
      return `padding-${this.spaceTop}--top`
    },
    getSpaceBottom() {
      return `padding-${this.spaceBottom}--bottom`
    }
  }
}
</script>

<style lang="scss" scoped>
.content-item {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: start; 
  align-items: flex-end;

  &.padding-small {
    &--bottom {
      margin-bottom: 8px;
      @media (min-width: 768px) {
        padding-bottom: 12px;
      }
      @media (min-width: 1200px) {
        padding-bottom: 16px;
      }
    }
    &--top {
      padding-top: 8px;
      @media (min-width: 768px) {
        padding-top: 12px;
      }
      @media (min-width: 1200px) {
        padding-top: 16px;
      }
    }
  }

  &.padding-medium {
    &--bottom {
      padding-bottom: 16px;
      @media (min-width: 768px) {
        padding-bottom: 20px;
      }
      @media (min-width: 1200px) {
        padding-bottom: 24px;
      }
    }
    &--top {
      padding-top: 16px;
      @media (min-width: 768px) {
        padding-top: 20px;
      }
      @media (min-width: 1200px) {
        padding-top: 24px;
      }
    }
  }

  &.padding-large {
    &--bottom {
      padding-bottom: 24px;
      @media (min-width: 768px) {
        padding-bottom: 28px;
      }
      @media (min-width: 1200px) {
        padding-bottom: 32px;
      }
    }
    &--top {
      padding-top: 24px;
      @media (min-width: 768px) {
        padding-top: 28px;
      }
      @media (min-width: 1200px) {
        padding-top: 32px;
      }
    }
  }

  &.padding-extralarge {
    &--bottom {
      padding-bottom: 32px;
      @media (min-width: 768px) {
        padding-bottom: 52px;
      }
      @media (min-width: 1200px) {
        padding-bottom: 72px;
      }
    }
    &--top {
      padding-top: 32px;
      @media (min-width: 768px) {
        padding-top: 52px;
      }
      @media (min-width: 1200px) {
        padding-top: 72px;
      }
    }
  }

  &.padding-xxl {
    &--bottom {
      padding-bottom: 64px;
      @media (min-width: 768px) {
        padding-bottom: 92px;
      }
      @media (min-width: 1200px) {
        padding-bottom: 120px;
      }
    }
    &--top {
      padding-top: 64px;
      @media (min-width: 768px) {
        padding-top: 92px;
      }
      @media (min-width: 1200px) {
        padding-top: 120px;
      }
    }
  }

  &--start {
    justify-content: flex-start; 
  }

  &--center {
    justify-content: center; 
  }

  &--end {
    justify-content: flex-end; 
  }
}
</style>